// extracted by mini-css-extract-plugin
export default {"container":"search_filters_selected-module__container--3prak"};